import React, { useEffect, useState, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import qrImage from "../assets/QR Code_img.jpeg";
import API from "../api";

const PrintInvoice = () => {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    const printRef = useRef();

    // Fetch Order
    const fetchOrder = useCallback(async () => {
        try {
            const res = await API.get(`/orders/${id}`);
            setOrder(res.data);
        } catch (err) {
            console.log(err);
        }
    }, [id]);

    // First Load
    useEffect(() => {
        fetchOrder();
    }, [fetchOrder]);

    // Auto Refresh (only if due > 0)
    useEffect(() => {
        if (!order) return;

        const due = order.dueAmount || 0;
        if (due <= 0) return;

        const interval = setInterval(() => {
            fetchOrder();
        }, 2000);

        return () => clearInterval(interval);
    }, [order, fetchOrder]);

    // PRINT AFTER FULL LOAD (FIXED)
    useEffect(() => {
        if (!order) return;

        const timer = setTimeout(() => {
            window.print();
        }, 1200);

        return () => clearTimeout(timer);
    }, [order]);


    if (!order || !order.items) {
        return <p>Loading Invoice...</p>;
    }

    const gstRateValue = Number(order.gstRate || 0);
    const orderGSTAmount = Number(order.taxAmount ?? order.totalGst ?? 0);

    const cgst = order.cgst !== undefined && order.cgst !== null
        ? Number(order.cgst)
        : gstRateValue / 2;
    const sgst = order.sgst !== undefined && order.sgst !== null
        ? Number(order.sgst)
        : gstRateValue / 2;

    const cgstAmount = order.cgstAmount !== undefined && order.cgstAmount !== null
        ? Number(order.cgstAmount)
        : Number(order.items.reduce((acc, i) => acc + (Number(i.gstAmount || 0) / 2), 0).toFixed(2));

    const sgstAmount = order.sgstAmount !== undefined && order.sgstAmount !== null
        ? Number(order.sgstAmount)
        : Number(order.items.reduce((acc, i) => acc + (Number(i.gstAmount || 0) / 2), 0).toFixed(2));

    const totalGST = orderGSTAmount || Number((cgstAmount + sgstAmount).toFixed(2));

    const grandTotal = Number(order.grandTotal || 0);

    const finalTotal = Number(order.finalTotal || 0);

    const roundOff = Number(order.roundOff || 0);

    console.log("ORDER DATA:", order);
    console.log("cgstAmount:", order.cgstAmount);
    console.log("sgstAmount:", order.sgstAmount);
    console.log("FULL ORDER:", JSON.stringify(order, null, 2));
    return (
        <div className="print-container">
            <div className="invoice-page"
                ref={printRef}
            >
                {/* 1. Header Section */}
                <div className="header-box">
                    <p className="type-label">Tax Invoice</p>
                    <h1 className="company-name">ABCD Shop</h1>
                    <p className="company-address">Paramanandapur, Moyna, Purba Medinipur, 721644</p>
                    <p className="company-contact">
                        GSTIN/UIN : xxxxxxxxxxxxxxx | Contact No.: +91 0000000000, +91 0000000000
                    </p>
                </div>

                {/* 2. Info Grid (Bill To & Invoice Details) */}
                <div className="info-grid">
                    <div className="info-col">
                        <div className="blue-header">Bill To</div>
                        <div className="info-content">
                            <p><span>Name:</span> {order.customer?.name}</p>
                            <p><span>Address:</span> {order.customer?.address}</p>
                            <p><span>State:</span> {order.customer?.state || "West Bengal"}</p>
                            <p><span>GSTIN:</span> {order.customer?.gstNumber}</p>
                            <p><span>Mobile No:</span> {order.customer?.phone}</p>
                        </div>
                    </div>
                    <div className="info-col">
                        <div className="blue-header">Invoice Details</div>
                        <div className="info-content">
                            <p><span># Inv. No.:</span> {order.invoiceNo}</p>
                            <p><span>Inv. Date:</span> {new Date(order.createdAt).toLocaleDateString()}</p>
                            <p><span>Buyers Order ID:</span> {order.orderId}</p>
                        </div>
                    </div>
                </div>

                {/* 3. Items Table */}
                <table className="invoice-table">
                    <thead>
                        <tr>
                            <th>Sr</th>
                            <th>Product Name</th>
                            <th>Category</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Total Rate</th>
                            <th>GST %</th>
                            <th>GST Amt.</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {order.items.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td className="text-left">{item.name}</td>
                                <td>
                                    {item.category || "General"}
                                </td>
                                <td>
                                    {item.qty}{" "}

                                    {
                                        item.sellType === "kg"
                                            ? "KG"
                                            : "PCS"
                                    }
                                </td>

                                <td>{Number(item.rate).toFixed(2)}</td>
                                <td>{Number(item.taxableValue).toFixed(2)}</td>
                                <td>{item.gstPercentage}%</td>
                                <td>{Number(item.gstAmount).toFixed(2)}</td>
                                <td>{Number(item.total).toFixed(2)}</td>
                            </tr>
                        ))}
                        <tr className="subtotal-row">
                            <td colSpan="3">Sub-Total:</td>
                            <td>{order.items.reduce((acc, i) => acc + i.qty, 0)}</td>
                            <td>-</td>

                            <td>{Number(order.subTotal).toFixed(2)}</td>
                            <td>-</td>
                            <td>{Number(order.taxAmount).toFixed(2)}</td>
                            <td>{Number(order.grandTotal).toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>

                {/* 4. Bottom Section */}
                <div className="footer-grid">
                    <div className="bottom-left">
                        <div className="blue-header">Our Bank Details</div>
                        <div className="bank-content">
                            <h4>Bank Details</h4>
                            <p>Bank Name: STATE BANK OF INDIA</p>
                            <p>Branch: Delhi</p>
                            <p>Account No: 20412XXXX05</p>
                            <p>IFSC Code: SBIN003XXXX</p>
                            <p>UPI ID: yourid@upi</p>
                        </div>

                        <div className="amount-words">
                            <div className="blue-header">Invoice Total in Words</div>
                            <p className="words-text">
                                {order.grandTotalInWords || "ZERO RUPEES ONLY"}
                            </p>
                        </div>
                        {/* NOTES */}
                        <div className="invoice-notes">
                            <h4>Notes:-</h4>

                            <p>
                                1. Please check material before delivery.
                            </p>

                        </div>
                    </div>

                    <div className="bottom-right">
                        <div className="totals-box">
                            <p>
                                <span>SUBTOTAL :</span>
                                <span>₹ {Number(order.subTotal).toFixed(2)}</span>
                            </p>
                            <p>
                                <span>CGST ({cgst}%):</span>
                                <span>₹ {cgstAmount.toFixed(2)}</span>
                            </p>

                            <p>
                                <span>SGST ({sgst}%):</span>
                                <span>₹ {sgstAmount.toFixed(2)}</span>
                            </p>

                            <p>
                                <span>Total GST ({cgst + sgst}%):</span>
                                <span>₹ {totalGST.toFixed(2)}</span>
                            </p>

                            <h3>
                                <span>Grand Total :</span>
                                <span>₹ {grandTotal.toFixed(2)}</span>
                            </h3>

                            <p>
                                <span>Round Off :</span>
                                <span>₹ {roundOff.toFixed(2)}</span>
                            </p>

                            <h3>
                                <span>Final Total :</span>
                                <span>₹ {finalTotal.toFixed(2)}</span>
                            </h3>


                            {/* PAID AMOUNT */}
                            <p className="final-paid">
                                <span>Paid Amount :</span>
                                <span>
                                    ₹ {Number(order.amountTendered || 0).toFixed(2)}
                                </span>
                            </p>

                            {/* DUE AMOUNT ONLY WHEN ACTIVE */}
                            {order.showDue === "active" && (
                                <p
                                    className="final-due"
                                    style={{
                                        color: "red",
                                        fontWeight: "bold",
                                        marginTop: "8px",
                                        fontSize: "18px"
                                    }}
                                >
                                    <span>Due Balance :</span>
                                    <span>
                                        ₹ {(order.dueAmount || 0).toFixed(2)}
                                    </span>
                                </p>
                            )}
                        </div>

                        {/* Payment Method */}
                        <div className="payment-box">
                            <h3>Payment Mode:</h3>

                            <div className="payment-row">
                                <span>Cash :</span>
                                <span>₹ {order.cashAmount || 0}</span>
                            </div>

                            <div className="payment-row">
                                <span>UPI :</span>
                                <span>₹ {order.upiAmount || 0}</span>
                            </div>


                        </div>

                        <div className="signature-section">
                            <div className="qr-placeholder">

                                <img
                                    src={qrImage}
                                    alt="QR Code"
                                />
                            </div>
                            <div className="auth-sign">
                                <div className="sign-line"></div>
                                <p>Authorised Signature</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PrintInvoice;



